/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { gettHeaderByType, settHeaderByType } from '@/api/common'
import { getBendCustomerConversionList, setbEndCustomerConversionUser, setCustomerConversion, customerBusinessExportData } from '@/api/customer'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import qrcodeVue from 'qrcode.vue'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData";

@Component({
  components: { qrcodeVue ,  MoreUsersFilter}
})
export default class ConversionTransfrom extends Vue {
    socket: any = null
    tableHeadPopoverShow = false
    tableData: any = []
    tableHeader: any = []
    checkTableRow: any = []
    tableHeadFilter = {
        name: '',
        sourceType: '',
        source: '',
        directorUserIdList: [],
        leaderUserIdList: [],
        createdAt: null,
        isSign: null,
        isPayment: '',
        courseTypeId: '',// 意向项目类型
        intentionality: '',// 意向程度
        gradeList: [],
        followIntentionalityList: [],
        followStatus: '',
        followAt: null,
        lastFollowAt: null,
    }
    page = 1
    limit = 20
    total = 0
    // tableRandom = Math.random()
    receiverUser = ''
    editReceiverUserDialog = false
    loading = false
    sendBackClueID: number; // 退户线索id
    menuBtn = menuBtn
    cancelTabkBackClueDialog = false
    cancelTabkBackClueId: number
    exportButtonDisabled = false
    qocodeDialog = false
    tableKey = Math.random()
    typeList= commonData.projectTypeArray
    gradeList = [  // 年级列表
        '美制7年级/英制8年级/初一（普高）',
        '美制8年级/英制9年级/初二（普高）',
        '美制9年级/英制10年级/初三（普高）',
        '美制10年级/英制11年级/高一（普高）',
        '美制11年级/英制12年级/高二（普高）',
        '美制12年级/英制13年级/高三（普高）',
        '大学一年级',
        '大学二年级',
        '大学三年级',
        '大学四年级',
        '研究生及以上',
        '已毕业'
    ]//学生年级
    followStatusOptions = [
        {
            label: '正常',
            value: '0'
        },
        {
            label: '即将超时',
            value: '1'
        },
        {
            label: '已超时',
            value: '2'
        },
    ] // 跟进状态
    followIntentionality= [
        '高',
        '中',
        '低',
        '暂无',
        '已签约',
        '已拒绝',
        '已退群/拉黑',
    ]
    timer = null
    draggableList = []
    draggableListChange = []
    vdaH = 0 //屏幕高度
    popHeight = 0


    // computed

    get userId() {
        return UserModule.userId
    }
    get checkTableRowList() {
        const newArr = [...new Set(this.checkTableRow.map(i => i.directorUserRealName))]; // 去重的时候需要注意和普通数组不同
        const list = [];
        newArr.forEach(i => {
            list.push(this.checkTableRow.filter(t => t.directorUserRealName === i));
        })
        const mlist = [];
        list.forEach((i, index) => {
            mlist.push({
                directorUserRealName: newArr[index],
                num: i.length,
            })
        })
        return mlist
    }
    get QrcodeUrl() {
        let str = window.location.origin + '/applicationForm'

        str += '?isH5=1'
        str += '&userId=' + this.userId
        str += '&from=customer'
        return str
      }

    // created
    created() {
        this.getTableHeader()
        if (this.userId) this.initSocket()
        const h = document.documentElement.clientHeight || document.body.clientHeight;
        this.vdaH = h - 260 ;
        this.popHeight = this.vdaH
    }

    destroyed() {
        // this.socket.disconnect()
    }

    // methods


    changeReceiverUsers(e) {
        this.receiverUser = e.id
    }

    changeDirectorUserIds(e) {
        this.tableHeadFilter.directorUserIdList = e.id
        this.page = 1
        this.getTableData()
    }

    txtClassFun(row ) {
        let cla = ''
        if(row.followStatus === '已超时'){ //已超时
            cla = 'red-txt'
        }else if(row.followStatus === '即将超时'){ //即将超时
            cla = 'orange-txt'
        }
        return cla
    }
    async getTableHeader() {
        this.loading = true
        const data: any = await gettHeaderByType(4)
        this.draggableList = data.headerUserList
        this.tableHeader = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.loading = false
        this.getTableData()
    }
    async getTableData() {
        this.loading = true

        const obj = this.removePropertyOfNull({ ...this.tableHeadFilter, page: this.page, limit: this.limit })
        if ('createdAt' in obj) {
            (function () {
                obj.createdAt = obj.createdAt.map((item: string) => {
                    return formatDate('yyyy-MM-dd', new Date(item))
                });
                obj.createdAt = obj.createdAt.join('/')
            })()
        }
        if ('followAt' in obj) {
            (function () {
                obj.followAt = obj.followAt.map((item: string) => {
                    return formatDate('yyyy-MM-dd', new Date(item))
                });
                obj.followAt = obj.followAt.join('&')
            })()
        }
        if ('lastFollowAt' in obj) {
            (function () {
                obj.lastFollowAt = obj.lastFollowAt.map((item: string) => {
                    return formatDate('yyyy-MM-dd', new Date(item))
                });
                obj.lastFollowAt = obj.lastFollowAt.join('&')
            })()
        }
        const data: any = await getBendCustomerConversionList(obj)
        const arr1 = data.customerBusinessList.map((item: any) => ({ ...item, isReceive: 0 })) // 添加状态，未接收线索
        // const arr2 = data.customerConversionList.map((item: TableRow) => ({ ...item, isReceive: 1 })) // 添加状态，已接收线索
        this.tableData = [...arr1]
        this.total = data.allNum
        this.tableKey = Math.random()
        this.$nextTick(() => {
            if (this.$refs.multipleTable) {
                (this.$refs.multipleTable as HTMLFormElement).doLayout();
                (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            }
        });
        this.loading = false

    }
    handleSelectionChange(arr: any) {
        this.checkTableRow = arr
    }
    addBClassifyCustomer() {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/addBClassifyCustomer?type=1')
        const time = setInterval(() => {
            if (win.closed) {

                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }
    openDtatisticsData() {
        window.open(window.location.origin + this.$route.matched[0].path + '/statisticsBClassifyCustomer')
    }
    exportExcel() {
        this.exportButtonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        const obj = this.removePropertyOfNull({ ...this.tableHeadFilter, page: this.page, limit: this.limit })
        if ('createdAt' in obj) {
            (function () {
                obj.createdAt = obj.createdAt.map((item: string) => {
                    return formatDate('yyyy-MM-dd', new Date(item))
                });
                obj.createdAt = obj.createdAt.join('/')
            })()
        }
        if ('followAt' in obj) {
            (function () {
                obj.followAt = obj.followAt.map((item: string) => {
                    return formatDate('yyyy-MM-dd', new Date(item))
                });
                obj.followAt = obj.followAt.join('/')
            })()
        }
        if ('lastFollowAt' in obj) {
            (function () {
                obj.followAt = obj.followAt.map((item: string) => {
                    return formatDate('yyyy-MM-dd', new Date(item))
                });
                obj.followAt = obj.followAt.join('/')
            })()
        }
        customerBusinessExportData(obj).then(() => {
            this.exportButtonDisabled = false
        }).catch(() => {
            this.exportButtonDisabled = false
        })
    }

    async draggableEnd() {
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({headerIds: this.draggableList, types: 4})
            this.$message.success('设置成功')
            this.tableHeadPopoverShow = false
            this.getTableHeader()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    doCancel(){
        this.draggableListChange = JSON.parse(JSON.stringify( this.draggableList))
        this.tableHeadPopoverShow = false

    }

    async confirmEditReceiverUser() {
        if(!this.receiverUser){
            this.$message.error('新负责人不可为空！')
            return
        }
        const idArray: string[] = this.checkTableRow.map((item: any) => item.id)
        await setbEndCustomerConversionUser({
            directorUserId: this.receiverUser,
            customerBusinessIdList: idArray
        })
        this.$message.success('修改负责人成功')
        this.editReceiverUserDialog = false
        this.getTableData()
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }
    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }
    ClickTableRow(row: any, col: any) {
        if (col.label === '操作') {
            window.open(`${window.location.origin + this.$route.matched[0].path}/bClassifyCustomerFollow?id=${row.id}&name=${row.name ? row.name : row.marketClueName}`, '_blank')
        } else {
            if (this.menuBtn(41)) { // 查看
                const win = window.open(window.location.origin + this.$route.matched[0].path + '/addBClassifyCustomer?id=' + row.id + '&type=2')
                const time = setInterval(() => {
                    if (win.closed) {
                        this.getTableData()
                        clearInterval(time)
                    }
                }, 500)
            }
        }
    }
    async receiveMarketClue(id: number) {
        await setCustomerConversion(id)
        this.$message.success('成功接收线索')
        this.getTableData()
    }


    initSocket() {
        // this.socket = io('wss://gec-api-testserver.gecacademy.cn', {
        //     path: '/crmServer/socket.io',
        //     query: {
        //         userId: this.userId,
        //         room: 'defaultRoom'
        //     },
        //     transports: ["websocket", "xhr-polling", "jsonp-polling"],
        //     autoConnect: false
        // })
        // this.socket.open()
        // this.socket.on('connect', () => {
        //     console.log('-----connect-----');
        // })
        // this.socket.on(this.userId, (res) => {
        //     if (res.type === 'marketClue') {
        //         this.getTableData()
        //     }
        // })
        // this.socket.on('disconnect', () => {
        //     console.log('断开连接');
        // })
        // const time = setInterval(() => {
        //     if(Vue.prototype.$socket.on) {
        //         realTimeSokcet(this.userId, 'marketClue', this.getTableData)
        //         clearInterval(time)
        //     }
        // }, 100)
    }
    clickFollow(row: any) {
        window.open(`${window.location.origin + this.$route.matched[0].path}/bClassifyCustomerFollow?id=${row.id}&name=${row.name ? row.name : row.marketClueName}`, '_blank')
    }
    removePropertyOfNull(object: any) {
        const obj = JSON.parse(JSON.stringify(object))
        Object.keys(obj).forEach(item => {
            if (!obj[item] || obj[item].length === 0) delete obj[item]
        })
        return obj;
    }

    changeTable(val) {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }


    // 防抖节流函数
    @Watch('editReceiverUserDialog')
    handleWatchEditReceiverUserDialog(val: boolean) {
        if (val === false) {
            this.receiverUser = ''
        }
    }
    @Watch('userId')
    handleWatchUserId(val: string) {
        this.initSocket()
    }
}
